import type { FC } from "react";

import { TextControl } from "@/ui/components/typography/TextControl";
import { DisplayState } from "@/constants/state";
import { TButtonProps } from "./Button.config";
import { Spinner } from "../Spinner";

export const ButtonChildren: FC<Pick<TButtonProps, "children" | "state">> = ({ state, children }) => (
  <TextControl
    tag="div"
    size={2}
    color="inherit"
    className="flex space-x-2 justify-between items-center"
    isResponsive={false}
  >
    { state === DisplayState.LOADING ? (
      <Spinner />
    ) : null }
    <span>
      { children }
    </span>
  </TextControl>
);
